export default {

    assignMemberContainer: {
        width: "100%",
        padding: "20px 20px 0px 20px",
        flex: "1 1 0%"
    },

    formContainer: {
        width: "60%"
    }
}
